import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: 16,
    padding: "18px 20px",
    borderRadius: 14,
    backgroundColor: theme.palette.type === "dark" ? "#1E293B" : "#FFFFFF",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "#F1F5F9"}`,
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
    height: "100%",
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 52,
    height: 52,
    borderRadius: 14,
    flexShrink: 0,
  },
  textWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0,
  },
  title: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    lineHeight: 1.3,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  value: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 22,
    fontWeight: 700,
    color: theme.palette.type === "dark" ? "#F1F5F9" : "#1E293B",
    lineHeight: 1.2,
  },
  skeleton: {
    borderRadius: 14,
  },
  infoBtn: {
    position: "absolute",
    top: 6,
    right: 6,
    padding: 4,
    color: theme.palette.type === "dark" ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.25)",
    "&:hover": {
      color: theme.palette.type === "dark" ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.5)",
      backgroundColor: "transparent",
    },
  },
  dialogContent: {
    fontFamily: '"Inter", "Poppins", sans-serif',
    fontSize: 14,
    lineHeight: 1.6,
    color: theme.palette.type === "dark" ? "#CBD5E1" : "#475569",
    paddingBottom: 20,
  },
}));

export default function CardCounter({ icon, title, value, loading, iconBg, infoTitle, infoContent }) {
  const classes = useStyles();
  const [infoOpen, setInfoOpen] = useState(false);

  if (loading) {
    return <Skeleton variant="rect" height={88} className={classes.skeleton} />;
  }

  return (
    <Box className={classes.card}>
      {infoContent && (
        <>
          <IconButton
            size="small"
            className={classes.infoBtn}
            onClick={() => setInfoOpen(true)}
            aria-label={infoTitle || "Informação"}
          >
            <InfoOutlinedIcon style={{ fontSize: 16 }} />
          </IconButton>
          <Dialog
            open={infoOpen}
            onClose={() => setInfoOpen(false)}
            maxWidth="xs"
            fullWidth
            PaperProps={{ style: { borderRadius: 14, padding: 0 } }}
          >
            <DialogTitle
              style={{
                fontFamily: '"Inter", "Poppins", sans-serif',
                fontSize: 16,
                fontWeight: 700,
              }}
            >
              {infoTitle || title}
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              {typeof infoContent === "string" ? (
                <Typography variant="body2" style={{ fontFamily: '"Inter", "Poppins", sans-serif' }}>
                  {infoContent}
                </Typography>
              ) : (
                infoContent
              )}
            </DialogContent>
          </Dialog>
        </>
      )}
      <Box
        className={classes.iconWrapper}
        style={{ backgroundColor: iconBg || "#E8EDF7" }}
      >
        {icon}
      </Box>
      <Box className={classes.textWrapper}>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.value}>
          {value !== undefined && value !== null ? value : 0}
        </Typography>
      </Box>
    </Box>
  );
}
